<template>
    <div class="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed"
        style="background-image: url('media/svg/illustrations/progress.svg')">  
        <div class="d-flex flex-column flex-column-fluid text-center p-10 py-lg-20"> 
            <span class="mb-10 pt-lg-20">
                <img alt="Logo" src="media/logos/logo-dark.png"/> 
                <!-- <img alt="Logo" src="media/logos/logo-2-dark.svg" class="h-50px mb-5" /> -->
            </span> 
            <div class="pt-lg-10"> 
                <h1 class="fw-bolder fs-4x text-gray-700 mb-10">Error de Permissão</h1> 
                <div class="fw-bold fs-3 text-gray-400 mb-15">
                    Algo inesperado aconteceu! 
                </div> 
                <div class="text-center">
                    <a href="#" class="btn btn-lg btn-pmes-primary fw-bolder">Verifique qual o perfil selecionado!</a>
                </div> 
            </div> 
        </div> 
        <div class="d-flex flex-center flex-column-auto p-10"> 
            <div class="d-flex align-items-center fw-bold fs-6">
                <router-link  to="/sobre" exact   class="nav-link pr-3 pl-0" >
                    {{ t('sobre')}}
                </router-link>
                <router-link  to="/equipe" exact  class="nav-link px-3" >
                    {{ t('equipe')}}
                </router-link>
                <router-link  to="/contato" exact  class="nav-link pl-3 pr-0" >
                    {{ t('contato')}}
                </router-link>  
            </div> 
        </div> 
    </div>
</template>

<script lang="ts">
    import { defineComponent } from "vue";
    import { useI18n } from "vue-i18n";

    export default defineComponent({
        name: "error-500",
        components: {},
        setup() {
            const { t } = useI18n(); 
            return {   t };
        }
    });
</script>
